import {
  FETCH_PURCHASE_RETURN_LIST,
  RESET_PURCHASE_RETURN_LIST,
} from "../../constants/action.constants";

//Storage for data.
const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 20,
  },
};

//Controller for the storage.
const purchaseReturnOrderListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PURCHASE_RETURN_LIST:
      return { list: action.payload, others: action.others};
    case RESET_PURCHASE_RETURN_LIST:
      return initialState;
    default:
      return state;
  }
};

export default purchaseReturnOrderListReducer;
